var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeEmployeePlanning
    ? _c("div", { staticClass: "container", attrs: { role: "main" } }, [
        _c(
          "article",
          [
            _c("h1", { staticClass: "mb-4" }, [
              _vm._v(_vm._s(_vm.$t("pages.planning.title"))),
            ]),
            _c(
              "div",
              { staticClass: "d-flex table-responsive p-2" },
              [
                _c("hours-planning-month-widget"),
                _c("hours-real-month-widget", { staticClass: "ml-4" }),
                _vm.activeHoursPack
                  ? _c("hour-balance-widget", { staticClass: "ml-4" })
                  : _vm._e(),
              ],
              1
            ),
            _c("planning-calendar-component", { staticClass: "mt-5" }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }